package ru.villawonka.app.presentation.screens.searchFilter.compose.view

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.unit.dp
import ru.villawonka.app.domain.model.AccommodationAdditionDomain
import ru.villawonka.app.presentation.design.components.AppFilledChip
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.presentation.screens.searchFilter.model.ChipUIModel
import ru.villawonka.app.resources.AppResources

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun ColumnScope.AdditionsCardView(
    chips: List<ChipUIModel<AccommodationAdditionDomain>>,
    callbacks: SearchFilterCallbacks,
) {
    CardView {
        Text(
            text = AppResources.strings.searchFilterAmenitiesLabel,
            style = AppTextStyles.bodyMediumRegular,
            color = MaterialTheme.colors.onSurfacePrimary
        )
        AppSpacer(12.dp)
        FlowRow(
            verticalArrangement = Arrangement.spacedBy(12.dp, Alignment.CenterVertically),
            horizontalArrangement = Arrangement.spacedBy(12.dp, Alignment.Start)
        ) {
            chips.forEach {
                AppFilledChip(
                    text = it.text,
                    focused = it.selected,
                    onClick = { callbacks.onAdditionsItemClick(it) }
                )
            }
        }
    }
}